export function getReviewAuthor(review: CompanyReview): string {
  if (review.type === "INTERNAL_COMPANY_REVIEW" && review.created_by !== null) {
    return `${review.created_by.user.first_name} ${review?.created_by.user.last_name && review.created_by.user.last_name.length > 0 ? `${review.created_by.user.last_name.charAt(0)}.` : ""}`;
  }
  if (
    review.type === "EXTERNAL_COMPANY_REVIEW" &&
    review.external_author !== null
  ) {
    return `${review.external_author.first_name} ${review.external_author.last_name && review.external_author.last_name.length > 0 ? `${review.external_author.last_name.charAt(0)}.` : ""}`;
  }
  return "";
}

export function getReviewCompany(review: CompanyReview): string {
  if (review.type === "INTERNAL_COMPANY_REVIEW" && review.created_by !== null) {
    return review.created_by.company.name;
  }
  if (
    review.type === "EXTERNAL_COMPANY_REVIEW" &&
    review.external_author?.company_name
  ) {
    return review.external_author.company_name;
  }
  return "";
}
